"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BooleanInt = _interopRequireDefault(require("./BooleanInt"));
var _Konto = _interopRequireDefault(require("./Konto"));
var _KundenAdresse = _interopRequireDefault(require("./KundenAdresse"));
var _LoggerInfo = _interopRequireDefault(require("./LoggerInfo"));
var _Personenart = _interopRequireDefault(require("./Personenart"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Kunde model module.
 * @module model/Kunde
 * @version 1.0.44
 */
var Kunde = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Kunde</code>.
   * Alle Informationen zu einem Kunden
   * @alias module:model/Kunde
   * @param nachname {String} Nachname des Kunden
   * @param vorname {String} Vorname des Kunden
   * @param strasse1 {String} Straße un Hausnummer der Abresse des Kunden
   * @param plz {String} Postleitzahl des Kunden
   * @param ort {String} Wohnort des Kunden 
   * @param email {String} E-Mail des Kunden
   * @param kundenkonto {String} Bankkonto des Kunden
   * @param nationalitaet {String} Nationalität des Kunden nach ISO
   * @param gebDatKunde {String} Datum im Format tt.mm.YYYY
   * @param gebOrtKunde {String} Geburtsort des Kunden
   * @param gebietsansaessigKz {module:model/BooleanInt} 
   * @param personArt {module:model/Personenart} 
   */
  function Kunde(nachname, vorname, strasse1, plz, ort, email, kundenkonto, nationalitaet, gebDatKunde, gebOrtKunde, gebietsansaessigKz, personArt) {
    _classCallCheck(this, Kunde);
    Kunde.initialize(this, nachname, vorname, strasse1, plz, ort, email, kundenkonto, nationalitaet, gebDatKunde, gebOrtKunde, gebietsansaessigKz, personArt);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Kunde, null, [{
    key: "initialize",
    value: function initialize(obj, nachname, vorname, strasse1, plz, ort, email, kundenkonto, nationalitaet, gebDatKunde, gebOrtKunde, gebietsansaessigKz, personArt) {
      obj['nachname'] = nachname;
      obj['vorname'] = vorname;
      obj['strasse1'] = strasse1;
      obj['plz'] = plz;
      obj['ort'] = ort;
      obj['email'] = email;
      obj['kundenkonto'] = kundenkonto;
      obj['nationalitaet'] = nationalitaet;
      obj['gebDatKunde'] = gebDatKunde;
      obj['gebOrtKunde'] = gebOrtKunde;
      obj['gebietsansaessigKz'] = gebietsansaessigKz;
      obj['personArt'] = personArt;
    }

    /**
     * Constructs a <code>Kunde</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Kunde} obj Optional instance to populate.
     * @return {module:model/Kunde} The populated <code>Kunde</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Kunde();
        if (data.hasOwnProperty('nachname')) {
          obj['nachname'] = _ApiClient.default.convertToType(data['nachname'], 'String');
        }
        if (data.hasOwnProperty('vorname')) {
          obj['vorname'] = _ApiClient.default.convertToType(data['vorname'], 'String');
        }
        if (data.hasOwnProperty('strasse1')) {
          obj['strasse1'] = _ApiClient.default.convertToType(data['strasse1'], 'String');
        }
        if (data.hasOwnProperty('strasse2')) {
          obj['strasse2'] = _ApiClient.default.convertToType(data['strasse2'], 'String');
        }
        if (data.hasOwnProperty('plz')) {
          obj['plz'] = _ApiClient.default.convertToType(data['plz'], 'String');
        }
        if (data.hasOwnProperty('ort')) {
          obj['ort'] = _ApiClient.default.convertToType(data['ort'], 'String');
        }
        if (data.hasOwnProperty('email')) {
          obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
        }
        if (data.hasOwnProperty('kundenkonto')) {
          obj['kundenkonto'] = _ApiClient.default.convertToType(data['kundenkonto'], 'String');
        }
        if (data.hasOwnProperty('nationalitaet')) {
          obj['nationalitaet'] = _ApiClient.default.convertToType(data['nationalitaet'], 'String');
        }
        if (data.hasOwnProperty('gebDatKunde')) {
          obj['gebDatKunde'] = _ApiClient.default.convertToType(data['gebDatKunde'], 'String');
        }
        if (data.hasOwnProperty('gebOrtKunde')) {
          obj['gebOrtKunde'] = _ApiClient.default.convertToType(data['gebOrtKunde'], 'String');
        }
        if (data.hasOwnProperty('gebietsansaessigKz')) {
          obj['gebietsansaessigKz'] = _BooleanInt.default.constructFromObject(data['gebietsansaessigKz']);
        }
        if (data.hasOwnProperty('personArt')) {
          obj['personArt'] = _Personenart.default.constructFromObject(data['personArt']);
        }
        if (data.hasOwnProperty('listKundenAdressen')) {
          obj['listKundenAdressen'] = _ApiClient.default.convertToType(data['listKundenAdressen'], [_KundenAdresse.default]);
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient.default.convertToType(data['userId'], 'String');
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('rechtlichesHinweis1')) {
          obj['rechtlichesHinweis1'] = _BooleanInt.default.constructFromObject(data['rechtlichesHinweis1']);
        }
        if (data.hasOwnProperty('rechtlichesHinweis2')) {
          obj['rechtlichesHinweis2'] = _BooleanInt.default.constructFromObject(data['rechtlichesHinweis2']);
        }
        if (data.hasOwnProperty('namenszusatz')) {
          obj['namenszusatz'] = _ApiClient.default.convertToType(data['namenszusatz'], 'String');
        }
        if (data.hasOwnProperty('konten')) {
          obj['konten'] = _ApiClient.default.convertToType(data['konten'], [_Konto.default]);
        }
        if (data.hasOwnProperty('logger')) {
          obj['logger'] = _LoggerInfo.default.constructFromObject(data['logger']);
        }
        if (data.hasOwnProperty('isMaShop')) {
          obj['isMaShop'] = _ApiClient.default.convertToType(data['isMaShop'], 'Boolean');
        }
        if (data.hasOwnProperty('registrationCountry')) {
          obj['registrationCountry'] = _ApiClient.default.convertToType(data['registrationCountry'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Kunde</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Kunde</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Kunde.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['nachname'] && !(typeof data['nachname'] === 'string' || data['nachname'] instanceof String)) {
        throw new Error("Expected the field `nachname` to be a primitive type in the JSON string but got " + data['nachname']);
      }
      // ensure the json data is a string
      if (data['vorname'] && !(typeof data['vorname'] === 'string' || data['vorname'] instanceof String)) {
        throw new Error("Expected the field `vorname` to be a primitive type in the JSON string but got " + data['vorname']);
      }
      // ensure the json data is a string
      if (data['strasse1'] && !(typeof data['strasse1'] === 'string' || data['strasse1'] instanceof String)) {
        throw new Error("Expected the field `strasse1` to be a primitive type in the JSON string but got " + data['strasse1']);
      }
      // ensure the json data is a string
      if (data['strasse2'] && !(typeof data['strasse2'] === 'string' || data['strasse2'] instanceof String)) {
        throw new Error("Expected the field `strasse2` to be a primitive type in the JSON string but got " + data['strasse2']);
      }
      // ensure the json data is a string
      if (data['plz'] && !(typeof data['plz'] === 'string' || data['plz'] instanceof String)) {
        throw new Error("Expected the field `plz` to be a primitive type in the JSON string but got " + data['plz']);
      }
      // ensure the json data is a string
      if (data['ort'] && !(typeof data['ort'] === 'string' || data['ort'] instanceof String)) {
        throw new Error("Expected the field `ort` to be a primitive type in the JSON string but got " + data['ort']);
      }
      // ensure the json data is a string
      if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
        throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
      }
      // ensure the json data is a string
      if (data['kundenkonto'] && !(typeof data['kundenkonto'] === 'string' || data['kundenkonto'] instanceof String)) {
        throw new Error("Expected the field `kundenkonto` to be a primitive type in the JSON string but got " + data['kundenkonto']);
      }
      // ensure the json data is a string
      if (data['nationalitaet'] && !(typeof data['nationalitaet'] === 'string' || data['nationalitaet'] instanceof String)) {
        throw new Error("Expected the field `nationalitaet` to be a primitive type in the JSON string but got " + data['nationalitaet']);
      }
      // ensure the json data is a string
      if (data['gebDatKunde'] && !(typeof data['gebDatKunde'] === 'string' || data['gebDatKunde'] instanceof String)) {
        throw new Error("Expected the field `gebDatKunde` to be a primitive type in the JSON string but got " + data['gebDatKunde']);
      }
      // ensure the json data is a string
      if (data['gebOrtKunde'] && !(typeof data['gebOrtKunde'] === 'string' || data['gebOrtKunde'] instanceof String)) {
        throw new Error("Expected the field `gebOrtKunde` to be a primitive type in the JSON string but got " + data['gebOrtKunde']);
      }
      if (data['listKundenAdressen']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['listKundenAdressen'])) {
          throw new Error("Expected the field `listKundenAdressen` to be an array in the JSON data but got " + data['listKundenAdressen']);
        }
        // validate the optional field `listKundenAdressen` (array)
        var _iterator2 = _createForOfIteratorHelper(data['listKundenAdressen']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _KundenAdresse.default.validateJSON(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      // ensure the json data is a string
      if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
        throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
      }
      // ensure the json data is a string
      if (data['namenszusatz'] && !(typeof data['namenszusatz'] === 'string' || data['namenszusatz'] instanceof String)) {
        throw new Error("Expected the field `namenszusatz` to be a primitive type in the JSON string but got " + data['namenszusatz']);
      }
      if (data['konten']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['konten'])) {
          throw new Error("Expected the field `konten` to be an array in the JSON data but got " + data['konten']);
        }
        // validate the optional field `konten` (array)
        var _iterator3 = _createForOfIteratorHelper(data['konten']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item = _step3.value;
            _Konto.default.validateJSON(_item);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      // validate the optional field `logger`
      if (data['logger']) {
        // data not null
        _LoggerInfo.default.validateJSON(data['logger']);
      }
      return true;
    }
  }]);
}();
Kunde.RequiredProperties = ["nachname", "vorname", "strasse1", "plz", "ort", "email", "kundenkonto", "nationalitaet", "gebDatKunde", "gebOrtKunde", "gebietsansaessigKz", "personArt"];

/**
 * Nachname des Kunden
 * @member {String} nachname
 */
Kunde.prototype['nachname'] = undefined;

/**
 * Vorname des Kunden
 * @member {String} vorname
 */
Kunde.prototype['vorname'] = undefined;

/**
 * Straße un Hausnummer der Abresse des Kunden
 * @member {String} strasse1
 */
Kunde.prototype['strasse1'] = undefined;

/**
 * Zusätzliche Infos zu Strasse des Kunden
 * @member {String} strasse2
 */
Kunde.prototype['strasse2'] = undefined;

/**
 * Postleitzahl des Kunden
 * @member {String} plz
 */
Kunde.prototype['plz'] = undefined;

/**
 * Wohnort des Kunden 
 * @member {String} ort
 */
Kunde.prototype['ort'] = undefined;

/**
 * E-Mail des Kunden
 * @member {String} email
 */
Kunde.prototype['email'] = undefined;

/**
 * Bankkonto des Kunden
 * @member {String} kundenkonto
 */
Kunde.prototype['kundenkonto'] = undefined;

/**
 * Nationalität des Kunden nach ISO
 * @member {String} nationalitaet
 */
Kunde.prototype['nationalitaet'] = undefined;

/**
 * Datum im Format tt.mm.YYYY
 * @member {String} gebDatKunde
 */
Kunde.prototype['gebDatKunde'] = undefined;

/**
 * Geburtsort des Kunden
 * @member {String} gebOrtKunde
 */
Kunde.prototype['gebOrtKunde'] = undefined;

/**
 * @member {module:model/BooleanInt} gebietsansaessigKz
 */
Kunde.prototype['gebietsansaessigKz'] = undefined;

/**
 * @member {module:model/Personenart} personArt
 */
Kunde.prototype['personArt'] = undefined;

/**
 * Liste mit zusätzlichen Kundenadressen
 * @member {Array.<module:model/KundenAdresse>} listKundenAdressen
 */
Kunde.prototype['listKundenAdressen'] = undefined;

/**
 * Referenz zu VerseNeo Kunde
 * @member {String} userId
 */
Kunde.prototype['userId'] = undefined;

/**
 * interne Id des Kunden
 * @member {Number} id
 */
Kunde.prototype['id'] = undefined;

/**
 * @member {module:model/BooleanInt} rechtlichesHinweis1
 */
Kunde.prototype['rechtlichesHinweis1'] = undefined;

/**
 * @member {module:model/BooleanInt} rechtlichesHinweis2
 */
Kunde.prototype['rechtlichesHinweis2'] = undefined;

/**
 * Erweiterung des Namens z.B. bei Gemeinschaftspersonen oder Überlauf bei Namen > 32 Zeichen
 * @member {String} namenszusatz
 */
Kunde.prototype['namenszusatz'] = undefined;

/**
 * Liste der Konten des Kunden
 * @member {Array.<module:model/Konto>} konten
 */
Kunde.prototype['konten'] = undefined;

/**
 * @member {module:model/LoggerInfo} logger
 */
Kunde.prototype['logger'] = undefined;

/**
 * gibt an, ob die Daten für den Mitarbeitershop geprüft werden müssen oder nicht, z.B. wenn sie in der VerSEneo Startseite gespeichert werden
 * @member {Boolean} isMaShop
 */
Kunde.prototype['isMaShop'] = undefined;

/**
 * Info in welchem Land der Kunde mit Meldeadresse registriert ist
 * @member {String} registrationCountry
 */
Kunde.prototype['registrationCountry'] = undefined;
var _default = exports.default = Kunde;